import { Stack } from '@mui/material';

import { Callout } from '@/components/notifications/Callout/Callout';

import { ApplicationRecordChanges } from './ApplicationRecordChangesConfirmationContent.utils';
import {
  AssetsChangesTable,
  BeneficiaryDesignationProvisionsChangesTables,
  DispositionScenarioProvisionsChangesTables,
  LiabilitiesChangesTable,
  LifeInsuranceChangesTable,
  PeopleAndEntitiesChangesTable,
} from './ApplicationRecordChangesTables';

export function ApplicationRecordChangesConfirmationContent({
  changes,
  warnings,
}: {
  changes: ApplicationRecordChanges;
  warnings: Array<{ message: string }>;
}) {
  return (
    <Stack gap={3}>
      {warnings.map((warning, index) => (
        <Callout key={`${warning.message}-${index}`} severity="warning">
          {warning.message}
        </Callout>
      ))}
      <PeopleAndEntitiesChangesTable changes={changes} />
      <AssetsChangesTable assets={changes.assets} />
      <LifeInsuranceChangesTable
        lifeInsurancePolicies={changes.lifeInsurancePolicies}
      />
      <LiabilitiesChangesTable liabilities={changes.liabilities} />
      <DispositionScenarioProvisionsChangesTables
        groups={changes.dispositionScenarioGroups}
      />
      <BeneficiaryDesignationProvisionsChangesTables
        groups={changes.beneficiaryDesignationGroups}
      />
    </Stack>
  );
}
